<template>
    <div class="glassbox">
        <div class="gb-title">
            <slot name="title"/>
        </div>
        <div class="gb-content">
            <slot name="content"/>
        </div>
        <div class="gb-footer">
            <slot name="footer"/>
        </div>
    </div>
</template>
    
<script>
    export default {
        name: 'GlassCard',
        components: {},
        setup(props) {
            return {}
        },
    }
</script>
    
<style>
    .glassbox{
        color: #dddddd;
        padding: 1em 0.8em;
        background: rgba(112, 112, 112, 0.158);
        border-radius: 16px;
        box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
        backdrop-filter: blur(5px) saturate(0.8) brightness(0.6);
        -webkit-backdrop-filter: blur(5px) saturate(0.8) brightness(0.6);
        border: 1px solid rgba(255, 255, 255, 0.75);
    }

    .gb-title, .gb-content, .gb-footer{
        filter: drop-shadow(0.1em 0.1em 0.2em black);
    }
    
    .gb-title{
        font-size: 1.7em;
        font-weight: 800;
    }

    .gb-content{
        font-size: 1.2em;
    }
</style>